import emotionIsPropValid from '@emotion/is-prop-valid';
export const isPropValid = (propName, target) => {
    if (typeof target === 'string') {
        if (propName === 'muted')
            return true;
        return emotionIsPropValid(propName);
    }
    return true;
};
//# sourceMappingURL=isPropValid.js.map